module.exports = __webpack_public_path__ + "static/zero-to-one-1767606184afee8fb38dd322fb85c424.jpg";